import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {ReviewQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const REVIEW = gql`
    query review($page: Int, $reviewCompany: String) {
        review(page: $page, review_company: $reviewCompany) {
            averageRating
            average12MonthsRating
            numberOfReviews
            numberOfReviews12Months
            percentageRecommended
            reviewUrl
            numberOfPages
            source
            surveyUrl
            reviewList {
                name
                city
                rating
                reviewComment
                reviewDate
                reviewContent {
                    question
                    answer
                }
                __typename
            }
            __typename
        }
    }
`;

export class Review {
    static async getReview(page: number, reviewCompany: string) {
        return await pwaClient.query<ReviewQuery>({
            query: REVIEW,
            variables: {
                page,
                reviewCompany,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
}
